var _excluded = ["logo", "socials", "categories", "hasToggleableCategoriesOnSmall", "partners", "footer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import BrandContext from "../../../contexts/BrandContext";
import ImageLinkAtm from "../../atoms/ImageLinkAtm";
import AlignContentOrg from "../../organisms/AlignContentOrg";
import ContainerOrg from "../../organisms/ContainerOrg";
import PushOrg from "../../organisms/PushOrg";
import SectionOrg from "../../organisms/SectionOrg";
import WrapOrg from "../../organisms/WrapOrg";
import Picture from "../../quarks/Picture";
import AdditionalFooterMol from "./AdditionalFooterMol";
import brandStyles from "./brandStyles";
import PageFooterCategory from "./PageFooterCategory";
import PageFooterOrg from "./PageFooterOrg";
function PageFooterTemplate(_ref) {
  var logo = _ref.logo,
    socials = _ref.socials,
    categories = _ref.categories,
    hasToggleableCategoriesOnSmall = _ref.hasToggleableCategoriesOnSmall,
    partners = _ref.partners,
    footer = _ref.footer,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var sectionBackground = brandStyles[useContext(BrandContext)].sectionBackground;
  return /*#__PURE__*/React.createElement("footer", {
    role: "contentinfo"
  }, /*#__PURE__*/React.createElement(SectionOrg, {
    color: sectionBackground
  }, /*#__PURE__*/React.createElement(ContainerOrg, null, /*#__PURE__*/React.createElement(PageFooterOrg, _extends({}, restProps, {
    logo: /*#__PURE__*/React.createElement(Picture, {
      srcData: logo.src,
      alt: logo.alt
    }),
    socials: socials ? /*#__PURE__*/React.createElement(WrapOrg, {
      gutterSpace: 4
    }, socials.map(function (social, socialIndex) {
      return (
        /*#__PURE__*/
        /* eslint-disable react/no-array-index-key */
        React.createElement(ImageLinkAtm, _extends({}, social, {
          hasOpacity: true,
          sizeSpace: 3
          // eslint-disable-next-line react/no-array-index-key
          ,
          key: "social-".concat(socialIndex)
        }))
      );
    })) : null,
    categories: categories.map(function (category) {
      return {
        content: /*#__PURE__*/React.createElement(PageFooterCategory, {
          category: category,
          isToggleable: hasToggleableCategoriesOnSmall
        }),
        isHiddenOnSmall: category.isHiddenOnSmall,
        isHiddenOnMedium: category.isHiddenOnMedium
      };
    }),
    partners: /*#__PURE__*/React.createElement(AlignContentOrg, {
      horizontalAlign: {
        small: "left",
        medium: "left",
        large: "right"
      }
    }, /*#__PURE__*/React.createElement("div", null, partners.map(function (partner, partnerIndex) {
      return /*#__PURE__*/React.createElement(PushOrg, {
        bottomSpace: 3,
        key: "partner-".concat(partnerIndex)
      }, /*#__PURE__*/React.createElement(Picture, {
        srcData: partner
      }));
    }))),
    footer: footer
  })))));
}
PageFooterTemplate.AdditionalFooter = AdditionalFooterMol;
export default PageFooterTemplate;